export const MAX_QUESTION_DESCRIPTION_LENGTH = 1500;
export const MAX_ANSWER_LENGTH = 500;
export const ANSWERS_LETTERS = 'ABCDEFGHIJ';
